import { type FC, type ReactNode } from "react";
import { useSelector } from "react-redux";
import { selectProductData } from "../../../../../../redux/products/productsSelectors";
import classNames from "classnames";
import { type SrpProductData } from "../../../../../../utils/models";
import { canSeeAddToCartButton, canSeeWishlistButton } from "~/utils/features";
import { AddToCartAction } from "~/Search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/AddToCartAction";
import { AddToWishlistAction } from "~/Search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/AddToWishlistAction";
import { OpenCadAction } from "~/Search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/OpenCadAction";
import { OpenCalcAction } from "~/Search/components/ProductResults/views/TabularView/ProductTabularViewActionCell/OpenCalcAction";

interface Props {
  productCode: string;
  isHousing?: boolean;
}

export const ProductTabularViewActionCell: FC<Props> = ({ productCode, isHousing = false }: Props) => {
  const product = useSelector(selectProductData(productCode)) as SrpProductData;

  const showWishlistBtn = canSeeWishlistButton();
  const showATCBtn = canSeeAddToCartButton();

  return (
    <div className={"scha__tabular-view__action-cell"}>
      <div className={"scha__tabular-view__action-cell__inner"}>
        <OpenCalcAction
          url={product.calcUrl}
          data-ta-spec={isHousing ? "housing_assistant_product_calc" : undefined}
          data-test-id={"tabular-view-action-button-calc"}
        />
        <OpenCadAction
          url={product.cadUrl}
          hasCad={product.hasCad}
          target={"_blank"}
          data-test-id={"tabular-view-action-button-cad"}
          data-ta-spec={isHousing ? "housing_assistant_product_cad" : undefined}
          data-ta-title={isHousing ? product.designation : undefined}
        />

        {showWishlistBtn && <AddToWishlistAction productCode={productCode} />}

        {showATCBtn && <AddToCartAction productCode={productCode} />}
        {!showATCBtn && <div />}
      </div>
    </div>
  );
};

export const ActionTextLinkCell: FC<{
  children?: ReactNode;
  href?: string;
  target?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}> = ({ onClick, disabled, className, ...rest }) => {
  const cls = classNames("action-text-cell", className, disabled && "disabled-ac-cell");
  return <a {...rest} className={cls} onClick={disabled ? () => {} : onClick} />;
};
